export const PIPELINE_API_GATEWAY_URI =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3196'
    : `${window.location.protocol}//${window.location.hostname.replace(
        'app.',
        'api.'
      )}`;

export const API_GATEWAY_URI =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:9000'
    : `${window.location.protocol}//${window.location.hostname.replace(
        'app.',
        'platform-api.'
      )}`;

export const GITSTREAM_REST_API = {
  LOGIN: `${PIPELINE_API_GATEWAY_URI}/auth/identity`
};
